import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { fetchonevehicle, vehicleSelector } from '../api/vehicles';
import TripDetailsCard from '../Listpage/TripDetailsCard';
import { FaUser } from 'react-icons/fa';
import { fetchoneroute_details, routeSelector } from '../api/route';
import { KeyUri } from '../key';
import { fetchpricingmodal, pricingSelector } from '../api/pricesetting';
import { createSelectorCreator } from '@reduxjs/toolkit';
import { fetchUserTerms, termsSelector } from '../api/termsSlice';

const PassengerForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const termsState = useSelector(termsSelector);
  console.log("SeatList mounted");
  console.log("Redux termsState:", termsState);
  const { currentTerms } = termsState;
  console.log("Current Terms:", currentTerms);

  useEffect(() => {
    console.log("Calling fetchUserTerms...");
    dispatch(fetchUserTerms());
  }, [dispatch]);

  const { current_vehicle } = useSelector(vehicleSelector);
  const [passenger, setPassenger] = useState({
    name: '',
    email: '',
    phone: '',
    gender: '',
    customGender: ''
  });
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { current_route } = useSelector(routeSelector);
  const retrievedData = JSON.parse(localStorage.getItem('Selected Data'));
  const { currentPricing } = useSelector(pricingSelector);
  const [totalAmount, setTotalAmount] = useState(0);
  const [gst, setGst] = useState(0);
  const [profit, setProfit] = useState(0);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [couponCode, setCouponCode] = useState('');
  const [couponMessage, setCouponMessage] = useState('');
  const [isCouponValid, setIsCouponValid] = useState(false);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [appliedCoupon, setAppliedCoupon] = useState(null);

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [pricing_obj, setPricing_obj] = useState({});
  const [basePrice, setBasePrice] = useState(0);

  //auth user
  const authUser = useSelector((state) => state.userauth?.user);


  const config = authUser ? {
    headers: {
      Authorization: `Bearer ${authUser.token}`,
      "Content-Type": "application/json",
    },
  } : {};


  useEffect(() => {
    const fetchVehicle = async () => {
      try {
        await dispatch(fetchonevehicle(id));
        await dispatch(fetchpricingmodal());
        await dispatch(fetchoneroute_details(retrievedData));
        setLoading(false);
      } catch (error) {
        setError("Failed to load vehicle details");
        setLoading(false);
      }
    };
    fetchVehicle();
  }, [dispatch, id]);

  useEffect(() => {
    if (currentPricing) {
      setGst(currentPricing[0]?.gst_price / 100);
      setProfit(currentPricing[0]?.platform_price_for_full_cabs / 100);
    }
  }, [currentPricing]);

  useEffect(() => {
    if (current_vehicle?.seats) {

      const autoSelectedSeats = current_vehicle.seats.filter(seat => seat !== 'D1');
      setSelectedSeats(autoSelectedSeats);
    }
  }, [current_vehicle]);

  // Update pricing object when currentPricing changes
  useEffect(() => {
    setPricing_obj(currentPricing?.[0] || {});
  }, [currentPricing]);
  // pricing for full cabs function 
  const getprice_for_fullcabs = useCallback(
    (car) => {
      if (!car || !pricing_obj || !current_route) return 0;

      if (pricing_obj?.pricing_model_for_fullcabs === "Driver Fixed") {
        const perTrip = (Number(car?.price_per_km?.$numberDecimal) * current_route?.no_of_kms);
        return perTrip * (1 + pricing_obj?.platform_price_for_full_cabs / 100);
      }

      if (pricing_obj?.pricing_model_for_fullcabs === "Admin Fixed") {
        const key =
          car.category === "Economy"
            ? "price_for_economy"
            : car.category === "Luxary"
              ? "price_for_luxary"
              : "price_for_premium";
        const base =
          Number(current_route[key]?.$numberDecimal) * (car.capacity - 1) || 0;
        return base * (1 + pricing_obj.platform_price_for_full_cabs / 100);
      }

      return 0;
    },
    [pricing_obj, current_route]
  );

  useEffect(() => {
    const calculatePrice = () => {
      if (!current_vehicle || !current_route || !currentPricing?.[0] || !selectedSeats.length) return;

      let basePrice = 0;

      if (currentPricing[0]?.pricing_model_for_fullcabs === 'Driver Fixed') {
        const distancePrice = parseFloat(current_vehicle?.price_per_km?.$numberDecimal || 0) * current_route.no_of_kms;
        basePrice = distancePrice * (1 + profit); // including platform profit
      } else if (currentPricing[0]?.pricing_model_for_fullcabs === 'Admin Fixed') {
        let routePrice = 0;
        if (current_vehicle.category === 'Premium' || current_vehicle.category === 'Standard') {
          routePrice = parseFloat(current_route.full_cab_price_for_premium?.$numberDecimal || 0);
        } else if (current_vehicle.category === 'Luxury') {
          routePrice = parseFloat(current_route.full_cab_price_for_luxary?.$numberDecimal || 0);
        } else if (current_vehicle.category === 'Economy') {
          routePrice = parseFloat(current_route.full_cab_price_for_economy?.$numberDecimal || 0);
        }
        basePrice = routePrice * (1) * (1 + profit);
        console.log("====>", basePrice)
      }
      setBasePrice(basePrice);

      // Subtract coupon discount
      let discountAmount = 0;
      if (appliedCoupon?.discount_type === 'percentage') {
        discountAmount = (couponDiscount / 100) * basePrice;
      } else {
        discountAmount = couponDiscount;
      }

      discountAmount = Math.min(discountAmount, basePrice); // prevent negative

      const afterDiscount = basePrice - discountAmount;

      // Add GST
      const gstAmount = afterDiscount * gst;

      const finalAmount = afterDiscount + gstAmount;

      setTotalAmount(finalAmount);
    };

    calculatePrice();
  }, [current_vehicle, current_route, gst, profit, selectedSeats, currentPricing, appliedCoupon, couponDiscount]);



  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponMessage("Please enter a coupon code.");
      setIsCouponValid(false);
      return;
    }

    // Assuming retrievedData has the ride date
    const ride_date = new Date(retrievedData?.date).toISOString();

    try {
      const response = await axios.post(
        `${KeyUri.BACKEND_URI}/redeem-coupon`,
        {
          userId: authUser._id,
          couponCode: couponCode.trim(),
          total: totalAmount,
          bookingDate: Date.now(),
          tripDate: ride_date,  // Use the ride_date here
        },
        config
      );

      if (response.data.success) {
        setIsCouponValid(true);
        setCouponMessage(response.data.message || "Coupon applied successfully!");
        setCouponDiscount(response.data.discountAmount || 0);  // Update the discount amount
        setAppliedCoupon({
          ...response.data,
          discountAmount: response.data.discountAmount || 0,  // Store the discount amount
          discount_type: response.data.discount_type,         // Store the discount type
        });
      } else {
        setIsCouponValid(false);
        setCouponDiscount(0);
        setCouponMessage(response.data.message || "This coupon is not valid for this user.");
      }
    } catch (error) {
      setIsCouponValid(false);
      setCouponDiscount(0);
      setCouponMessage(
        error.response?.data?.message || "This coupon is not valid for this user."
      );
    }
  };

  const toggleTermsModal = () => {
    setShowTermsModal(!showTermsModal);
  };


  const handlePayment = async () => {
    try {
      const { data } = await axios.post(`${KeyUri.BACKEND_URI}/payment/create-order`, {
        amount: totalAmount,
        passengers: {
          S1: passenger
        },
        vehicle: current_vehicle?._id,
        route: current_route?._id,
        selectedSeats: selectedSeats,
        mainPassenger: 'S1',
        ride_date_and_time: new Date(retrievedData?.date).toISOString(),
        pickup_point: retrievedData?.pickupStreet,
        drop_point: retrievedData?.dropStreet
      });

      const options = {
        key: process.REACT_APP_RAZORPAY_KEY_ID,
        amount: data?.data?.amount,
        currency: data?.data?.currency,
        name: "The Great Himalayas",
        description: "Full Vehicle Booking",
        order_id: data?.data?.id,
        handler: async (response) => {
          navigate('/sharedcabbookingconfirmed', {
            state: {
              paymentId: response.razorpay_payment_id,
              rideid: data?.dataa?._id
            }
          });
        },
        prefill: {
          name: passenger.name,
          email: passenger.email,
          contact: passenger.phone,
        },
        theme: { color: "#3399CC" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Payment error:", error);
      alert("Payment failed. Please try again.");
    }
  };

  const validateForm = () => {
    if (!passenger.name || !passenger.email || !passenger.phone) {
      return "All fields are required";
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(passenger.email)) {
      return "Invalid email format";
    }
    if (!/^\d{10}$/.test(passenger.phone)) {
      return "Invalid phone number (must be 10 digits)";
    }
    if (passenger.gender === 'Other' && !passenger.customGender) {
      return "Please specify gender for 'Other' selection";
    }
    return null;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const error = validateForm();
    if (error) return setError(error);
    setError(null);
    setShowModal(true);
  };

  if (loading) return <div className="text-center py-8">Loading...</div>;
  if (!current_vehicle) return <div className="text-center py-8">Vehicle not found</div>;

  return (
    <div className="mx-auto flex flex-col lg:flex-row gap-8 p-4 max-w-7xl mb-14 lg:mt-32 font-lato">

      {/* Terms & Conditions Modal */}
      {showTermsModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={toggleTermsModal}>
          <div
            className="bg-white rounded-lg shadow-lg max-w-xl w-full p-6 relative"
            onClick={(e) => e.stopPropagation()} // Prevent closing modal when clicking inside content
          >
            <h3 className="text-lg font-bold mb-4">Terms and Conditions</h3>
            <div className="max-h-64 overflow-y-auto text-sm text-gray-700 space-y-2">

              {currentTerms && (
                <div
                  dangerouslySetInnerHTML={{ __html: currentTerms }}
                  className="prose max-w-none"
                />
              )}
            </div>
            <div className="mt-4 text-right">
              <button
                onClick={toggleTermsModal}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="w-full lg:w-2/3 space-y-8">
        <TripDetailsCard vehicle={current_vehicle} />
        <div className="bg-white shadow-md rounded-lg p-6 flex items-center gap-4">
          <img
            src={current_vehicle.picture_of_the_vehicle}
            alt={current_vehicle.brand_name + '' + current_vehicle.model_name}
            className="w-32 h-32 object-cover rounded-md"
          />
          <div>
            <h3 className="text-lg font-bold">{current_vehicle.brand_name} {current_vehicle.model_name}</h3>
            <p className="text-gray-600">{(current_vehicle.seats?.length) - 1} Seater</p>
            <p className="text-blue-600 font-bold text-lg mt-2">
              ₹{basePrice.toFixed(2)} total
            </p>
            <p className="text-sm text-gray-500 mt-1">
              (Including all seats except driver seat)
            </p>
          </div>
        </div>
      </div>

      <div className="w-full lg:w-1/3 space-y-6">
        <form onSubmit={handleSubmit} className="bg-gray-50 p-6 rounded-lg shadow">
          <h2 className="text-2xl font-semibold mb-6">Passenger Details</h2>

          {error && <div className="text-red-500 mb-4">{error}</div>}

          <div className="space-y-4">
            <input
              type="text"
              placeholder="Full Name"
              value={passenger.name}
              onChange={e => setPassenger(prev => ({ ...prev, name: e.target.value }))}
              className="w-full p-2 border rounded"
              required
            />

            <input
              type="email"
              placeholder="Email"
              value={passenger.email}
              onChange={e => setPassenger(prev => ({ ...prev, email: e.target.value }))}
              className="w-full p-2 border rounded"
              required
            />

            <input
              type="tel"
              placeholder="Phone"
              value={passenger.phone}
              onChange={e => setPassenger(prev => ({ ...prev, phone: e.target.value }))}
              className="w-full p-2 border rounded"
              pattern="\d{10}"
              required
            />

            <div className="space-y-2">
              <label>Gender:</label>
              <div className="flex gap-4">
                {[' Male', ' Female', ' Other'].map(gender => (
                  <label key={gender}>
                    <input
                      type="radio"
                      name="gender"
                      value={gender}
                      checked={passenger.gender === gender}
                      onChange={e => setPassenger(prev => ({
                        ...prev,
                        gender: e.target.value,
                        customGender: e.target.value === 'Other' ? '' : prev.customGender
                      }))}
                    />
                    {gender}
                  </label>
                ))}
              </div>

              {passenger.gender === 'Other' && (
                <input
                  type="text"
                  placeholder="Specify Gender"
                  value={passenger.customGender}
                  onChange={e => setPassenger(prev => ({ ...prev, customGender: e.target.value }))}
                  className="w-full p-2 border rounded"
                  required
                />
              )}
            </div>
            {/* Coupon Application Section */}
            <div className="bg-white p-4 mt-6 rounded-md shadow-sm border">
              <h3 className="text-lg font-medium mb-2">Apply Coupon</h3>

              <div className="flex flex-col md:flex-row gap-4">
                <input
                  type="text"
                  placeholder="Enter Coupon Code"
                  value={couponCode}
                  onChange={(e) => {
                    setCouponCode(e.target.value);
                    setCouponMessage("");
                  }}
                  className="flex-1 p-2 border rounded"
                />
                <button
                  type="button"
                  onClick={handleApplyCoupon}
                  className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                >
                  Apply
                </button>
              </div>


              {couponMessage && (
                <p className={`mt-2 text-sm ${isCouponValid ? 'text-green-600' : 'text-red-600'}`}>
                  {couponMessage}
                </p>
              )}
            </div>
          </div>

          <div className="mt-4 flex items-start gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              id="couponTerms"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              className="mt-1"
            />
            <label htmlFor="couponTerms">
              I agree to the{' '}
              <button
                type="button"
                onClick={toggleTermsModal}
                className="text-blue-600 underline hover:text-blue-800"
              >
                Terms & Conditions
              </button>
            </label>
          </div>

          <button
            type="submit"
            disabled={selectedSeats.length === 0 || !termsAccepted}
            className={`mt-6 w-full py-2 text-white rounded 
    ${!termsAccepted ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
          >
            Proceed to Payment
          </button>
        </form>
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-lg">
              <h3 className="text-xl font-bold mb-4">Confirm Booking</h3>
              <p className="mb-2">Booked Seats: {selectedSeats.join(', ')}</p>

              {/* Base fare before discount and GST */}
              <div className="mb-2 flex justify-between">
                <span>Base Fare:</span>
                <span>₹{basePrice.toFixed(2)}</span>
              </div>

              {/* Show discount if applied */}
              {couponDiscount > 0 && (
                <div className="mb-2 flex justify-between text-green-600">
                  <span>Discount:</span>
                  <span>- ₹{Math.min(couponDiscount, basePrice).toFixed(2)}</span>
                </div>
              )}

              {/* Show GST amount */}
              <div className="mb-2 flex justify-between">
                <span>GST :</span>
                <span>
                  ₹{((basePrice - Math.min(couponDiscount, basePrice)) * gst).toFixed(2)}
                </span>
              </div>

              {/* Final total payable amount */}
              <div className="mb-4 flex justify-between font-semibold border-t pt-2">
                <span>Total Payable:</span>
                <span>₹{totalAmount.toFixed(2)}</span>
              </div>

              <div className="flex justify-end gap-4">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 border rounded"
                >
                  Cancel
                </button>
                <button
                  onClick={handlePayment}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Confirm Payment
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default PassengerForm;